import { Box, Flex } from "@chakra-ui/react";
import React from "react";

/**
 * Chrome-less page layout that grows with content and scrolls when it overflows.
 *
 * Use for surfaces that need no sidebar (deep-linked forms, one-off flows) but
 * whose content can be arbitrarily long — a long form response, a multi-section
 * flow. Pairs with {@link NoSidebarPage}, which is vertically centered and
 * clipped at 100vh (good for a short login card, bad for a long form).
 */
export default function NoSidebarScrollablePage({
  children = undefined,
  maxContentWidth = { base: "100%", md: "640px" },
}: {
  children?: React.ReactNode;
  maxContentWidth?: { base: string; md: string } | string;
}) {
  return (
    <Box minH="100vh" bg="bg.canvas" overflowY="auto">
      <Flex justify="center" py={{ base: 6, md: 12 }} px={4}>
        <Box w={maxContentWidth} maxW="100%">
          {children}
        </Box>
      </Flex>
    </Box>
  );
}
